/** Préfixe référence objet trouvé (aligné sur FoundObjectController::buildFoundObjectReferenceCode). */
export function getFoundObjectReferencePrefix(providerId: number, date = new Date()): string {
  const yy = String(date.getFullYear()).slice(-2);
  return `T${providerId}${yy}-`;
}

export function isReferenceSuffixOnly(value: string): boolean {
  return /^\d+$/.test(value.trim());
}

export function sanitizeReferenceSuffixInput(raw: string): string {
  return raw.replace(/\D/g, '');
}

export function formatReferenceFilterLabel(providerId: number | undefined, suffix: string): string {
  if (!suffix.trim()) return '';
  if (providerId) {
    return `${getFoundObjectReferencePrefix(providerId)}${suffix.trim()}`;
  }
  return suffix.trim();
}
